module.exports = __webpack_public_path__ + "media/custom/images/img9-b29bbc3e97e938f130e15a53e2835ae7.png";